import { Injectable } from '@angular/core'
import { DynamicDialogRef } from 'primeng/dynamicdialog'

@Injectable({
  providedIn: 'root'
})
export class DialogCleanupService {
  private dialogRefs: DynamicDialogRef[] = []

  constructor() {
    window.onhashchange = (event) => {
      this.dialogRefs.forEach((dialogRef) => dialogRef.destroy())
      this.dialogRefs = []
    }
  }

  registerDialog(ref: DynamicDialogRef) {
    this.dialogRefs.push(ref)
  }
}
